import { getAuth } from 'firebase/auth';

export const handleLogout = async (callbacks: (() => void)[]) => {
  try {
    await getAuth().signOut();
    window.location.reload();
    console.log('User signed out successfully.');
    // 执行所有回调函数
    callbacks.forEach((callback) => callback());
  } catch (error) {
    console.error('Error signing out:', error);
  }
};
